export default "__VITE_ASSET__BklTIIxX__"